// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_1G_","cls2":"ProfilePdfPackCard-cls2_cmz ProfilePdfPackCard-cls1_1G_","pack-label":"ProfilePdfPackCard-pack-label_xDi"};